<div class="grammar" *ngIf="showLink"
(click)="openGrammar()">
    <i class="material-icons" >spellcheck</i> {{ 'CONTEXTMENU.GRAMMAR' | translate }}
</div>



